<template>
  <div class="curso-main-container pb-3">
    <BannerInterno></BannerInterno>
    <div class="container tarjeta tarjeta--blanca p-4 p-md-5 mb-5">
      <div class="titulo-principal color-acento-contenido">
        <div class="titulo-principal__numero"><span>5</span></div>
        <h1>Herramientas y métodos de análisis</h1>
      </div>
      <div class="row justify-content-center mb-4">
        <div class="col-lg-8 my-lg-0 my-3">
          <p>
            En los sistemas productivos agropecuarios, la planificación y
            gestión integrada de recursos es fundamental para garantizar la
            eficiencia, sostenibilidad y rentabilidad. Esta gestión involucra la
            administración coordinada de recursos clave como el agua, el suelo,
            la energía y los insumos agrícolas, buscando maximizar la producción
            mientras se minimizan los impactos negativos sobre el medio
            ambiente.
          </p>
          <div class="bg2 p-4 brad">
            <p class="mb-0">
              La integración de herramientas tecnológicas y estrategias de
              planificación basadas en datos permite a los productores tomar
              decisiones informadas, adaptarse a condiciones cambiantes y
              optimizar el uso de los recursos disponibles. Este capítulo
              abordará la importancia de la planificación agrícola, los modelos
              de gestión integrada y las estrategias para optimizar recursos en
              sistemas productivos automatizados.
            </p>
          </div>
        </div>
        <div class="col-lg-4 my-lg-0 my-3">
          <img class="img-a img-t" src="@/assets/curso/temas/86.png" alt="" />
        </div>
      </div>
      <Separador> </Separador>
      <div
        id="t_5_1"
        class="titulo-segundo color-acento-contenido"
        data-aos="zoom-in-left"
      >
        <h2>5.1 Importancia de la planificación basada en datos</h2>
      </div>
      <p>
        La planificación agrícola basada en datos es un enfoque que utiliza
        información cuantitativa y cualitativa recopilada de diversas fuentes,
        como sensores, SIG y análisis históricos, para tomar decisiones
        estratégicas en el manejo de los sistemas productivos, siendo su
        objetivo el asegurar que cada recurso se utilice de manera óptima,
        alineando las prácticas agrícolas con las condiciones específicas del
        entorno y las necesidades del mercado.
      </p>
      <div class="row justify-content-start mt-5 mb-4">
        <div class="col-auto">
          <div class="list">
            <div class="list__item">
              <div class="list__item__icon">
                <img class="ms-2" src="@/assets/curso/temas/icon.svg" alt="" />
              </div>
            </div>
            <div class="list__txt bgicon brad p-0 px-4">
              <h4 class="mb-1">Ventajas de la planificación basada en datos</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center text-center mb-4">
        <div class="col-lg-4 my-3">
          <div class="bg6 brad p-3 sha h-100">
            <img
              class="img-a img-t mb-4"
              src="@/assets/curso/temas/87.png"
              alt=""
            />
            <h5>Toma de decisiones informada</h5>
            <p>
              Los datos precisos y actualizados permiten ajustar las prácticas
              de manejo en tiempo real.
            </p>
          </div>
        </div>
        <div class="col-lg-4 my-3">
          <div class="bg6 brad p-3 sha h-100">
            <img
              class="img-a img-t mb-4"
              src="@/assets/curso/temas/88.png"
              alt=""
            />
            <h5>Reducción de riesgos</h5>
            <p>
              La planificación basada en datos ayuda a anticipar problemas como
              sequías, plagas o fluctuaciones en el mercado.
            </p>
          </div>
        </div>
        <div class="col-lg-4 my-3">
          <div class="bg6 brad p-3 sha h-100">
            <img
              class="img-a img-t mb-4"
              src="@/assets/curso/temas/89.png"
              alt=""
            />
            <h5>Optimización de recursos</h5>
            <p>
              Permite un uso eficiente de insumos, reduciendo costos y mejorando
              la sostenibilidad.
            </p>
          </div>
        </div>
      </div>
      <Separador> </Separador>
      <div
        id="t_5_2"
        class="titulo-segundo color-acento-contenido"
        data-aos="zoom-in-left"
      >
        <h2>5.2 Modelos de gestión integrada de recursos</h2>
      </div>
      <div class="row justify-content-center mb-4">
        <div class="col-lg-5 my-lg-0 my-3">
          <img class="img-a img-t" src="@/assets/curso/temas/90.png" alt="" />
        </div>
        <div class="col-lg-7 my-lg-0 my-3">
          <div
            class="row justify-content-center align-items-center bg3 p-4 brad h-100"
          >
            <div class="col-lg-auto">
              <img
                class="img-a img-t"
                src="@/assets/curso/temas/91.png"
                alt=""
              />
            </div>
            <div class="col pt-lg-0 pt-md-4">
              <p class="mb-0">
                La gestión integrada de recursos implica la administración
                coordinada de los distintos insumos y elementos naturales que
                son esenciales para la producción agropecuaria. Este enfoque
                busca equilibrar la producción con la conservación de recursos,
                promoviendo prácticas agrícolas sostenibles.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-start mt-5 mb-4">
        <div class="col-auto">
          <div class="list">
            <div class="list__item">
              <div class="list__item__icon">
                <img class="ms-2" src="@/assets/curso/temas/icon.svg" alt="" />
              </div>
            </div>
            <div class="list__txt bgicon brad p-0 px-4">
              <h4 class="mb-1">Gestión integrada del agua</h4>
            </div>
          </div>
        </div>
      </div>
      <p>
        El agua es un recurso crítico en los sistemas productivos, especialmente
        en contextos de creciente escasez. La gestión integrada del agua incluye
        estrategias como el riego eficiente, la captación de agua de lluvia y el
        reciclaje de aguas residuales.
      </p>
      <div class="row bg8 align-items-center">
        <div class="col-lg-12 col-12 px-lg-5 px-4">
          <div class="row justify-content-center align-items-center">
            <div class="col-lg-12">
              <div class="bgw brad p-5 my-5">
                <CarouselRED tipo="b">
                  <div class="row justify-content-center">
                    <div class="col-lg-6 my-2">
                      <h5 class="mb-4">Tecnologías clave</h5>
                      <ul class="lista-ul fa-ul">
                        <li>
                          <i class="fas fa-check-circle color1"></i
                          ><span
                            ><b>Sistemas de riego automatizado:</b> basados en
                            sensores de humedad del suelo y datos
                            climáticos.</span
                          >
                        </li>
                        <li>
                          <i class="fas fa-check-circle color1"></i
                          ><span
                            ><b>Modelos de predicción de demanda hídrica:</b>
                            calculan las necesidades de riego en función de las
                            condiciones específicas del cultivo y el clima.
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-lg-5 my-2">
                      <img
                        class="img-a img-t"
                        src="@/assets/curso/temas/92.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <div class="col-lg-6 my-2">
                      <h5 class="mb-4">Beneficios</h5>
                      <ul class="lista-ul fa-ul">
                        <li>
                          <i class="fas fa-check-circle color1"></i
                          ><span>Reducción en el consumo de agua.</span>
                        </li>
                        <li>
                          <i class="fas fa-check-circle color1"></i
                          ><span>Mejora en la eficiencia del riego.</span>
                        </li>
                        <li>
                          <i class="fas fa-check-circle color1"></i
                          ><span
                            >Conservación de recursos hídricos a largo plazo.
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-lg-5 my-2">
                      <img
                        class="img-a img-t"
                        src="@/assets/curso/temas/93.png"
                        alt=""
                      />
                    </div>
                  </div>
                </CarouselRED>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center mb-4">
        <div class="col-lg-8 my-3">
          <div class="row justify-content-start mt-5 mb-4">
            <div class="col-auto">
              <div class="list">
                <div class="list__item">
                  <div class="list__item__icon">
                    <img
                      class="ms-2"
                      src="@/assets/curso/temas/icon.svg"
                      alt=""
                    />
                  </div>
                </div>
                <div class="list__txt bgicon brad p-0 px-4">
                  <h4 class="mb-1">Gestión integrada del suelo</h4>
                </div>
              </div>
            </div>
          </div>
          <p>
            El manejo sostenible del suelo es fundamental para mantener la
            productividad y la salud de los sistemas agrícolas. Esto incluye
            prácticas como la rotación de cultivos, la incorporación de materia
            orgánica y el monitoreo constante de la fertilidad del suelo.
          </p>
          <div class="bg3 p-4 brad">
            <h5>Tecnologías clave</h5>
            <ol class="lista-ol--cuadro fa-ul">
              <li>
                <div class="lista-ol--cuadro__vineta">
                  <span class="text-black">1</span>
                </div>
                <span
                  ><b>Análisis geoespacial del suelo:</b> utilizando SIG para
                  identificar zonas con diferentes niveles de fertilidad.</span
                >
              </li>
              <li>
                <div class="lista-ol--cuadro__vineta">
                  <span class="text-black">2</span>
                </div>
                <span
                  ><b>Sensores de calidad del suelo:</b> monitorean pH,
                  contenido de nutrientes y salinidad.
                </span>
              </li>
            </ol>
          </div>
        </div>
        <div class="col-lg-4 my-3">
          <img
            class="img-a img-t mb-4"
            src="@/assets/curso/temas/94.png"
            alt=""
          />
        </div>
      </div>
      <h5>Beneficios</h5>
      <div class="row justify-content-center mb-4">
        <div class="col-lg-4 my-3">
          <div class="bg6 brad p-3 sha h-100">
            <div class="row justify-content-center align-items-center">
              <div class="col-lg-auto">
                <img
                  class="img-a img-t"
                  src="@/assets/curso/temas/95.png"
                  alt=""
                />
              </div>
              <div class="col pt-lg-0 pt-md-4">
                <p class="mb-0">
                  Mantenimiento de la estructura y fertilidad del suelo.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 my-3">
          <div class="bg6 brad p-3 sha h-100">
            <div class="row justify-content-center align-items-center">
              <div class="col-lg-auto">
                <img
                  class="img-a img-t"
                  src="@/assets/curso/temas/96.png"
                  alt=""
                />
              </div>
              <div class="col pt-lg-0 pt-md-4">
                <p class="mb-0">Prevención de la erosión y la salinización.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 my-3">
          <div class="bg6 brad p-3 sha h-100">
            <div class="row justify-content-center align-items-center">
              <div class="col-lg-auto">
                <img
                  class="img-a img-t"
                  src="@/assets/curso/temas/97.png"
                  alt=""
                />
              </div>
              <div class="col pt-lg-0 pt-md-4">
                <p class="mb-0">
                  Optimización de la aplicación de fertilizantes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-start mt-5 mb-4">
        <div class="col-auto">
          <div class="list">
            <div class="list__item">
              <div class="list__item__icon">
                <img class="ms-2" src="@/assets/curso/temas/icon.svg" alt="" />
              </div>
            </div>
            <div class="list__txt bgicon brad p-0 px-4">
              <h4 class="mb-1">Gestión integrada de la energía</h4>
            </div>
          </div>
        </div>
      </div>
      <p>
        El consumo de energía en los sistemas productivos puede ser
        significativo, especialmente en actividades como el bombeo de agua, la
        climatización de invernaderos y el funcionamiento de maquinaria
        agrícola.
      </p>
      <div class="row justify-content-center">
        <div class="col-lg-4 my-lg-0 my-3">
          <img class="img-a img-t" src="@/assets/curso/temas/98.png" alt="" />
        </div>
        <div class="col-lg-8 my-lg-0 my-3">
          <AccordionRED tipo="a" clase-tarjeta="tarjeta bg7">
            <div titulo="Estrategias de eficiencia energética">
              <ul class="lista-ul fa-ul">
                <li>
                  <i class="fas fa-check-circle color1"></i
                  ><span
                    >Uso de energías renovables: como paneles solares y
                    biodigestores para reducir la dependencia de combustibles
                    fósiles.</span
                  >
                </li>
                <li>
                  <i class="fas fa-check-circle color1"></i
                  ><span
                    >Automatización de procesos energéticamente intensivos:
                    optimización del consumo en sistemas de riego y ventilación.
                  </span>
                </li>
              </ul>
            </div>
            <div titulo="Beneficios">
              <ul class="lista-ul fa-ul">
                <li>
                  <i class="fas fa-check-circle color1"></i
                  ><span>Reducción de costos operativos.</span>
                </li>
                <li>
                  <i class="fas fa-check-circle color1"></i
                  ><span
                    >Disminución de la huella de carbono del sistema
                    productivo.</span
                  >
                </li>
                <li>
                  <i class="fas fa-check-circle color1"></i
                  ><span>Contribución a la sostenibilidad ambiental.</span>
                </li>
              </ul>
            </div>
          </AccordionRED>
        </div>
      </div>
      <Separador> </Separador>
      <div
        id="t_5_3"
        class="titulo-segundo color-acento-contenido"
        data-aos="zoom-in-left"
      >
        <h2>
          5.3 Optimización de recursos en sistemas productivos automatizados
        </h2>
      </div>
      <p>
        La automatización permite un manejo más preciso y eficiente de los
        recursos en los sistemas productivos. A través del uso de tecnologías
        avanzadas, es posible ajustar las prácticas de manejo en función de las
        condiciones específicas de cada zona dentro de una parcela.
      </p>
      <div class="row justify-content-start mt-5 mb-4">
        <div class="col-auto">
          <div class="list">
            <div class="list__item">
              <div class="list__item__icon">
                <img class="ms-2" src="@/assets/curso/temas/icon.svg" alt="" />
              </div>
            </div>
            <div class="list__txt bgicon brad p-0 px-4">
              <h4 class="mb-1">Uso de sensores para optimización</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="row bg8 align-items-center">
        <div class="col-lg-12 col-12 px-lg-5 px-4">
          <div class="row justify-content-center align-items-center">
            <div class="col-lg-12">
              <div class="bgw brad p-5 my-5">
                <CarouselRED tipo="b">
                  <div class="row justify-content-center">
                    <div class="col-lg-6 my-2">
                      <h5 class="mb-4">Uso de sensores para optimización</h5>
                      <ul class="lista-ul fa-ul">
                        <li>
                          <i class="fas fa-check-circle color1"></i
                          ><span
                            ><b>Sensores de humedad y calidad del suelo:</b>
                            proveen datos en tiempo real que permiten ajustar la
                            aplicación de riego y fertilizantes según las
                            necesidades específicas del cultivo.</span
                          >
                        </li>
                        <li>
                          <i class="fas fa-check-circle color1"></i
                          ><span
                            ><b>Sensores climáticos:</b> ayudan a prever
                            condiciones adversas, como heladas o sequías,
                            permitiendo una respuesta proactiva.
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-lg-5 my-2">
                      <img
                        class="img-a img-t"
                        src="@/assets/curso/temas/99.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <div class="col-lg-6 my-2">
                      <h5 class="mb-4">Beneficios:</h5>
                      <ul class="lista-ul fa-ul">
                        <li>
                          <i class="fas fa-check-circle color1"></i
                          ><span>Reducción del desperdicio de insumos.</span>
                        </li>
                        <li>
                          <i class="fas fa-check-circle color1"></i
                          ><span
                            >Mejora en la productividad y uniformidad del
                            cultivo.</span
                          >
                        </li>
                        <li>
                          <i class="fas fa-check-circle color1"></i
                          ><span>Menor impacto ambiental. </span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-lg-5 my-2">
                      <img
                        class="img-a img-t"
                        src="@/assets/curso/temas/100.png"
                        alt=""
                      />
                    </div>
                  </div>
                </CarouselRED>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-start mt-5 mb-4">
        <div class="col-auto">
          <div class="list">
            <div class="list__item">
              <div class="list__item__icon">
                <img class="ms-2" src="@/assets/curso/temas/icon.svg" alt="" />
              </div>
            </div>
            <div class="list__txt bgicon brad p-0 px-4">
              <h4 class="mb-1">Plataformas de análisis de datos</h4>
            </div>
          </div>
        </div>
      </div>
      <p>
        El análisis de datos recopilados por sensores y otras fuentes es muy
        importante para la toma de decisiones. Plataformas como SCADA y software
        de agricultura de precisión integran estos datos, facilitando su
        interpretación.
      </p>
      <h5>Funciones clave</h5>
      <div class="row justify-content-center mb-4">
        <div class="col-lg-4 my-3">
          <div class="bg6 brad p-3 sha h-100">
            <div class="row justify-content-center align-items-center">
              <div class="col-lg-auto">
                <img
                  class="img-a img-t"
                  src="@/assets/curso/temas/101.png"
                  alt=""
                />
              </div>
              <div class="col pt-lg-0 pt-md-4">
                <p class="mb-0">Identificación de patrones y tendencias.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 my-3">
          <div class="bg6 brad p-3 sha h-100">
            <div class="row justify-content-center align-items-center">
              <div class="col-lg-auto">
                <img
                  class="img-a img-t"
                  src="@/assets/curso/temas/102.png"
                  alt=""
                />
              </div>
              <div class="col pt-lg-0 pt-md-4">
                <p class="mb-0">Generación de alertas y recomendaciones.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 my-3">
          <div class="bg6 brad p-3 sha h-100">
            <div class="row justify-content-center align-items-center">
              <div class="col-lg-auto">
                <img
                  class="img-a img-t"
                  src="@/assets/curso/temas/103.png"
                  alt=""
                />
              </div>
              <div class="col pt-lg-0 pt-md-4">
                <p class="mb-0">
                  Simulación de escenarios para evaluar diferentes estrategias
                  de manejo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div class="titulo-sexto color-acento-contenido">
            <h5>Figura 5.</h5>
            <span
              >Resumen herramientas y métodos de análisis en sistemas
              productivos y agropecuarios</span
            >
          </div>
          <div class="bgfig p-4 mb-1">
            <img
              class="img-a img-t"
              src="@/assets/curso/temas/104.svg"
              alt="El diagrama se divide en cuatro ramas principales que abarcan la planificación y gestión integrada de recursos, herramientas tecnológicas para decisiones informadas, modelos de gestión integrada, y estrategias de optimización de recursos en sistemas automatizados. Cada rama se desglosa en subtemas específicos relacionados con la gestión agropecuaria."
            />
          </div>
          <figcaption class="mb-5">Fuente: OIT, 2024.</figcaption>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tema5',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
